const API_URL = process.env.REACT_APP_API_URL || '';

const apiFetch = (path, options = {}) => {

    const fullUrl = `${API_URL}${path}`;
    const fetchOptions = {
        ...options,
        credentials: 'include'
    };
    return fetch(fullUrl, fetchOptions);
};

export default apiFetch;